class SaveForLater {
  /** The list id of the SFL list */
  listId = null;
  /** Cached items */
  items = [];

  /** The element to render the SFL products */
  renderOn = null;
  /** The HTML of the SFL product card */
  cardSection = '';
  swat = window._swat;
  /** The id of the section to be fetched and used to render each sfl item (via Sections API) */
  cardSectionId = 'cart-sfl-item-card';

  addToSflBtns = document.querySelectorAll('[data-sfl-action="add"]');
  removeFromSflBtns = document.querySelectorAll('[data-sfl-action="remove"]');

  /** event listeners applied to the data-sfl-action=* buttons */
  listeners = [];
  /** callbacks to be called when the product is added to SFL */
  addCallbacks = [];
  /** callbacks to be called when the product is removed from SFL */
  removeCallbacks = [];

  alertTemplate = document.getElementById("added-to-sfl-alert");
  alertTimeout = null;

  /** Callback to be called when the list is empty */
  onEmpty = null;
  
  /** Sort */
  sort = {
    'default': (a, b) => a.cts - b.cts,
    'recently-added': (a, b) => b.cts - a.cts,
    'a-z': (a, b) => a.dt.localeCompare(b.dt),
    'z-a': (a, b) => b.dt.localeCompare(a.dt),
    'price-low-to-high': (a, b) => a.pr - b.pr,
  }
  currentSort = 'default';

  constructor({
    swat,
    onAdd,
    onEmpty,
    onRemove,
    cardSection,
    cardSectionId,
    renderOnElement,
  }) {
    this.onEmpty = onEmpty || null;
    this.swat = swat || window._swat;
    this.cardSection = cardSection || '';
    this.renderOn = renderOnElement || null;
    this.cardSectionId = cardSectionId || 'cart-sfl-item-card';

    if(onAdd) this.onAdd(onAdd);
    if(onRemove) this.onRemove(onRemove);

    this.setButtons();

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
  
    window.SwymCallbacks.push(this.init.bind(this));
  }

  init(swat) {
    this.swat = swat || window._swat;
    this.resetButtons();

    function onSuccess(response) {
      this.listId = response.listid;
      this.fetchSFLProducts();
    }

    swat.SaveForLater.init(onSuccess.bind(this), console.error.bind(this));
  }
  
  /**
   * Fetch and renders the SFL products.
   * @returns {Promise} - The promise of the fetch
  */
  fetchSFLProducts() {
    const renderOn = document.getElementById(this.renderOn.id);
    const thiz = this;
    if(!this.cardSectionId || !renderOn) return;

    return new Promise((resolve, reject) => {
      thiz.swat.SaveForLater.fetch(thiz.listId, function(response) {
        const items = response.items;
        thiz.items = items;

        if(!items || !items.length) {
          thiz.onEmpty && thiz.onEmpty();
          thiz.registerActions();
          return;
        }

        thiz.renderItems(items);
        resolve(items);
      }, function(error) {
        reject(error);
      });
    });
  }

  renderItems(items) {
    if(!items || !items.length) items = this.items;
    if(!items || !items.length) {
      this.onEmpty && this.onEmpty();
      return;
    };

    const thiz = this;

    const promises = items.map(async (item, idx) => (await thiz.parseItem(item, idx)));
    const results = Promise.allSettled(promises);
    
    results.then((results) => {
      const itemsContent = results.map((result) => result.value).join('');
      this.renderOn.innerHTML = itemsContent;
      this.registerActions();
    });
  }

  /**
   * Parses the section with the item data.
   * @param {*} item - The item to be parsed
   * @param {number} idx - The index of the item
   * @returns {Promise<string>} - The parsed item HTML
   */
  async parseItem(item, idx) {
    if(!item) return '';

    let itemContent = await this.fetchProduct(item);
    itemContent = itemContent.replace(new RegExp(`{item.idx}`, 'g'), idx);

    return itemContent;
  }

  /**
   * Fetch the product details.
   * @param {*} item - The item to be fetched
   * @returns {Promise} - The promise of the fetch
   * @returns {object} - The product details
  */
  async fetchProduct(item) {
    if(!item) return {};
    if(!item.epi || !item.empi) return {};

    const url = new URL(item.du);
    url.searchParams.set('section_id', this.cardSectionId);
    const productPage = await fetch(url.toString());
    const productPageContent = await productPage.text();

    const parser = new DOMParser();
    const productPageDocument = parser.parseFromString(productPageContent, 'text/html');
    const productSection = productPageDocument.getElementById(`shopify-section-${this.cardSectionId}`);
    const content = productSection.querySelector('*>:first-of-type');

    return content.outerHTML;
  }

  /**
   * Register the actions for the buttons.
  */
  registerActions() {
    this.setButtons();
    const thiz = this;

    this.addToSflBtns.forEach(function(button) {
      const { line, quantity, variantId, productId, productUrl, productTitle } = button.dataset;
      if(!line || !quantity || !variantId || !productId || !productUrl) return;

      if(thiz.isRegistered(button)) return;

      function addToSFLEvent() {
        thiz.addProductToSFL({ lineId: line, variantId, productId, quantity, productUrl })
          .then((response) => {
            thiz.renderAlert(button.closest('.cart-item'), { title: productTitle, id: productId, url: productUrl, variant_id: variantId })
            thiz.addCallbacks.forEach((callback) => callback(response));
            thiz.fetchSFLProducts();
          })
          .catch((error) => console.error(error));
      }

      button.addEventListener('click', addToSFLEvent);
      thiz.addListener(button, addToSFLEvent);
    });

    this.removeFromSflBtns.forEach(function(button) {
      const { line, variantId, productId, productUrl } = button.dataset;
      if(!variantId || !productId || !productUrl) return;
      
      if(thiz.isRegistered(button)) return;

      function removeFromSFLEvent() {
        thiz.removeProductFromSFL({ lineId: line, variantId, productId, productUrl })
          .then((response) => {
            thiz.removeCallbacks.forEach((callback) => callback(response));
            thiz.fetchSFLProducts();
          })
          .catch((error) => console.error(error));
      }

      button.addEventListener('click', removeFromSFLEvent);
      thiz.addListener(button, removeFromSFLEvent);
    });
  }

  async addProductToSFL(product) {
    if(!this.swat || !product) return;
    if(!product.variantId || !product.productId || !product.quantity || !product.productUrl) return;

    return new Promise((resolve, reject) => {
      this.swat.SaveForLater.add(this.listId, [{
        epi: product.variantId,
        empi: product.productId,
        du: product.productUrl, 
        qty: product.quantity,
      }], function(response) {
        resolve({ response, product });
      }, function(error) {
        reject(error);
      });
    });
  }

  async removeProductFromSFL(product) {
    if(!this.swat || !product) return;
    if(!product.variantId || !product.productId || !product.productUrl) return;

    return new Promise((resolve, reject) => {
      this.swat.SaveForLater.remove(this.listId, [{
        epi: product.variantId,
        empi: product.productId,
        du: product.productUrl, 
      }], function(response) {
        resolve({ response, product });
      }, function(error) {
        reject(error);
      });
    });
  }

  /**
   * Sort the items and render them.
   * @param {*} sort - The sort to be applied
   * @param {*} render - If the items should be rendered after sorting
   * @returns {array} - The sorted items
   */
  sortItems(sort, render = false) {
    if(!sort) return;
    if(!this.sort[sort]) return;
    if(!this.items.length) return;

    this.currentSort = sort;
    const sorted = this.items.sort(this.sort[sort]);
    if(render) this.renderItems(sorted);

    return sorted;
  }

  renderAlert(replaceThis, item) {
    if(!this.alertTemplate) return;
    if(!replaceThis) return;

    const content = this.alertTemplate.cloneNode(true).content;
    const alert = content.querySelector('.added-to-sfl-alert');
    if(!alert) return;
    
    let itemContent = alert.innerHTML;
    Object.keys(item).forEach((key) => {
      itemContent = itemContent.replace(new RegExp(`{item.${key}}`, 'g'), item[key]);
    });

    alert.id = `added-to-sfl-alert-${Date.now()}`;
    alert.innerHTML = itemContent;
    replaceThis.replaceWith(alert);

    this.alertTimeout = setTimeout(() => {
      document.contains(alert) && alert.remove();
      clearTimeout(this.alertTimeout);
    }, 5000);
  }

  onAdd(callback) {
    if(!callback) return;
    if(this.addCallbacks.includes(callback)) return;
    this.addCallbacks.push(callback);
  }

  onRemove(callback) {
    if(!callback) return;
    if(this.removeCallbacks.includes(callback)) return;
    this.removeCallbacks.push(callback);
  }

  setButtons() {
    this.addToSflBtns = document.querySelectorAll('[data-sfl-action="add"]');
    this.removeFromSflBtns = document.querySelectorAll('[data-sfl-action="remove"]');
  }

  resetButtons() {
    [...this.addToSflBtns, ...this.removeFromSflBtns].forEach((button) => {
      button.removeAttribute('data-registered');
    });
  }

  addListener(button, event) {
    if(!button || !event) return;
    if(this.isRegistered(button)) return;

    this.listeners.push([button, event]);
  }

  isRegistered(button) {
    let registered = false;

    this.listeners.forEach(([registeredButton]) => {
      if(registeredButton === button) registered = true;
    });

    return registered;
  }

  unRegisterActions() {
    this.listeners.forEach(([button, event]) => {
      button.removeEventListener('click', event);
    });
  }
}